export default __webpack_public_path__ + "static/media/gusto.762f0b7d.svg";